import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HowItWorksTutorialComponent } from '../how-it-works-tutorial/how-it-works-tutorial/how-it-works-tutorial.component';
import { DownloadTutorialComponent } from "../download-tutorial/download-tutorial/download-tutorial.component.spec";

@Component({
  standalone: true,
  selector: 'app-how-it-works-page',
  imports: [RouterLink, HowItWorksTutorialComponent, DownloadTutorialComponent],
  templateUrl: './how-it-works-page.component.html',
  styleUrl: './how-it-works-page.component.css',
})
export class HowItWorksPageComponent {}
